/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useMemo, useState } from 'react';
import { createContext, PropsWithChildren } from 'react';
import { KazooDeviceCredentials, KazooDeviceLock, VoiceApi } from '../../services/api-client/voice-api';
import { DeviceLockStatus, PhoneLockContextState } from './types';
import { useOidc } from '@revenuewell/logic-oidc';

export const PhoneLockContext = createContext<PhoneLockContextState>(null!);

export const PhoneLockProvider = ({ children }: PropsWithChildren<{}>) => {
  const { signinRedirect } = useOidc();
  const [deviceLockStatus, setDeviceLockStatus] = useState<DeviceLockStatus>();
  const [deviceLockCredentials, setDeviceLockCredentials] = useState<KazooDeviceCredentials>();

  const tryLockDevice = async (deviceId: string, clientId: string, force?: boolean) => {
    let lockStatus = null;

    console.log(`PHONE LOCK [${new Date().toISOString()}] -> TRY LOCK DEVICE REQUEST.`);

    try {
      const voiceApi = VoiceApi.getInstance();
      const credentials = await voiceApi.createPendingDeviceLock(deviceId, clientId, force);
      setDeviceLockCredentials(credentials);
      lockStatus = 'current-client-pending';
    } catch (ex) {
      lockStatus = hadnleNonOkLockResponse(ex);
    }

    console.log(`PHONE LOCK [${new Date().toISOString()}] -> TRY LOCK DEVICE RESPONSE. \nSTATUS: ${lockStatus}`);
    // @ts-ignore
    setDeviceLockStatus(lockStatus);
  };

  const finalizePhoneLock = async (deviceId: string, clientId: string): Promise<void> => {
    let lockStatus = null;

    console.log(`PHONE LOCK [${new Date().toISOString()}] -> FINALIZE LOCK REQUEST.`);

    try {
      const voiceApi = VoiceApi.getInstance();
      const deviceLock = await voiceApi.finalizeDeviceLock(deviceId, clientId);
      lockStatus = mapKazooDeviceLock(deviceLock, clientId);
    } catch (ex) {
      lockStatus = hadnleNonOkLockResponse(ex);
    }

    console.log(`PHONE LOCK [${new Date().toISOString()}] -> FINALIZE LOCK RESPONSE. \nSTATUS: ${lockStatus}`);

    setDeviceLockStatus(lockStatus);
  };

  const getDeviceLockStatus = async (deviceId: string, clientId: string): Promise<DeviceLockStatus> => {
    let lockStatus = null;

    try {
      const voiceApi = VoiceApi.getInstance();
      const deviceLock = await voiceApi.getDeviceLockInfo(deviceId);
      // @ts-ignore
      lockStatus = mapKazooDeviceLock(deviceLock, clientId);
    } catch (ex) {
      lockStatus = hadnleNonOkLockResponse(ex);
    }

    console.log(`PHONE LOCK [${new Date().toISOString()}] -> FETCH LOCK STATUS. \nSTATUS: ${lockStatus}`);
    return lockStatus;
  };

  // low performance impact request to ckeck if current device is ineed has phone lock
  const checkActiveDeviceHasLock = async (deviceId: string, clientId: string): Promise<void> => {
    const lockStatus = await getDeviceLockStatus(deviceId, clientId);
    if (lockStatus !== 'current-client-active') setDeviceLockStatus(lockStatus);
  };

  const mapKazooDeviceLock = (deviceLock: KazooDeviceLock, clientId: string): DeviceLockStatus => {
    if (deviceLock.clientId === clientId)
      return deviceLock.lockStatus === 'active' ? 'current-client-active' : 'current-client-pending';
    else return 'in-use-by-other-client';
  };

  // @ts-ignore
  const hadnleNonOkLockResponse = (ex: any): DeviceLockStatus => {
    switch (ex.status) {
      case 401:
        signinRedirect();
        break;
      case 409:
        return 'in-use-by-other-client';
      default:
        console.error('PHONE LOCK -> ERROR: ', ex.message);
        break;
    }
  };

  const contextValue = useMemo(
    () => ({
      deviceLockStatus,
      deviceLockCredentials,
      tryLockDevice,
      checkActiveDeviceHasLock,
      finalizePhoneLock
    }),
    [deviceLockStatus, deviceLockCredentials]
  );

  return <PhoneLockContext.Provider value={contextValue}>{children}</PhoneLockContext.Provider>;
};
